import { createStore } from "vuex";
import axios from "axios";
import router from "../router";
import applicantFlow from './modules/applicantFlow'

const store = createStore({
  
  state() {
    return {
      loading: false,
      baseURL: "https://musafir.customs.ly/api/",
      // baseURL: "http://localhost:5041/",
      departs: [],
      departsApp: [],
      exceptTypes: [],
      transTypes: [],
      transMades: [],
      cities: [],
      docTypes: [],
      groups: [],
      inspectors: [],
      nationalities: [],
      user: {},
    };
  },
  /** */
   modules: {
    applicantFlow
  },
  /************/
  getters: {
    /** */
    isLoading: (state) => state.loading,
    /** */
    getDeparts(state) {
      return router.currentRoute.value.fullPath.split("/")[1] == "admin"
        ? state.departs
        : state.departsApp;
    },
    getExceptTypes(state) {
      return state.exceptTypes;
    },
    getTransTypes(state) {
      return state.transTypes;
    },
    getTransMades(state) {
      return state.transMades;
    },
    getCities(state) {
      return state.cities;
    },
    getDocTypes(state) {
      return state.docTypes;
    },
    getGroups(state) {
      return state.groups;
    },
    getInspectors(state) {
      return state.inspectors;
    },
    getNationalities(state) {
      return state.nationalities;
    },
    getUser(state) {
      return state.user;
    },
  },
  mutations: {
    /** */
    setLoading(state, status) {
      state.loading = status;
    },
    /** */
    setDeparts(state, departs) {
      state.departs = departs;
    },
    setDepartsApp(state, departsApp) {
      state.departsApp = departsApp;
    },
    setExceptTypes(state, exceptTypes) {
      state.exceptTypes = exceptTypes;
    },
    setTransTypes(state, transTypes) {
      state.transTypes = transTypes;
    },
    setTransMades(state, transMades) {
      state.transMades = transMades;
    },
    setCities(state, cities) {
      state.cities = cities;
    },
    setDocTypes(state, docTypes) {
      state.docTypes = docTypes;
    },
    setGroups(state, groups) {
      state.groups = groups;
    },
    setInspectors(state, inspectors) {
      state.inspectors = inspectors;
    },
    setNationalities(state, nationalities) {
      state.nationalities = nationalities;
    },
    setUser(state, user) {
      state.user = user;
      sessionStorage.setItem("user", JSON.stringify(user));
    },
  },
  actions: {
    /** */
    startLoading({ commit }) {
      commit('setLoading', true);
    },
    stopLoading({ commit }) {
      commit('setLoading', false);
    },
    /** */
    async fetchDeparts({ commit }) {
      try {
        const response = await axios.get(
          this.state.baseURL + "api/depart/getall",
          { withCredentials: true }
        );
        if (response?.data.isSuccess) {
          commit("setDeparts", response.data.departs);
          if (response.data.departs[0].id == 1) {
            commit("setDepartsApp", response.data.departs.slice(1));
          } else {
            commit("setDepartsApp", response.data.departs);
          }
        } else {
          console.log(response.data.msg);
          return false;
        }
      } catch (error) {
        console.error("Error fetching departs:", error);
      }
    },
    async fetchExceptTypes({ commit }) {
      try {
        const response = await axios.get(
          this.state.baseURL + "api/employee/except/gettypes",
          { withCredentials: true }
        );
        if (response?.data.isSuccess) {
          commit("setExceptTypes", response.data.types);
        } else {
          console.log(response.data.msg);
          return false;
        }
      } catch (error) {
        console.error("Error fetching Exception Types:", error);
      }
    },
    async fetchTransTypes({ commit }) {
      try {
        const response = await axios.get(
          this.state.baseURL + "api/trans/gettypes"
        );
        if (response?.data.isSuccess) {
          commit("setTransTypes", response.data.types);
        } else {
          console.log(response.data.msg);
          return false;
        }
      } catch (error) {
        console.error("Error fetching transTypes:", error);
      }
    },
    async fetchTransMades({ commit }) {
      try {
        const response = await axios.get(
          this.state.baseURL + "api/trans/getmades"
        );
        if (response?.data.isSuccess) {
          commit("setTransMades", response.data.mades);
        } else {
          console.log(response.data.msg);
          return false;
        }
      } catch (error) {
        console.error("Error fetching transMades:", error);
      }
    },
    async fetchCities({ commit }) {
      try {
        const response = await axios.get(
          this.state.baseURL + "api/city/getall"
        );
        if (response?.data.isSuccess) {
          commit("setCities", response.data.cities);
        } else {
          console.log(response.data.msg);
          return false;
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    },
    async fetchDocTypes({ commit }) {
      try {
        const response = await axios.get(
          this.state.baseURL + "api/docs/gettypes"
        );
        if (response?.data.isSuccess) {
          commit("setDocTypes", response.data.docTypes);
        } else {
          console.log(response.data.msg);
          return false;
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    },
    async fetchGroups({ commit }) {
      try {
        const response = await axios.get(
          this.state.baseURL + "api/employee/priv/getallgroups",
          { withCredentials: true }
        );
        if (response?.data.isSuccess) {
          commit("setGroups", response.data.groups);
        } else {
          console.log(response.data.msg);
          return false;
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    },
    /** */
    async fetchInspectors({ commit }) {
      try {
        const response = await axios.get(
          this.state.baseURL + "api/employee/user/getallinspectors",
          { withCredentials: true }
        );
        if (response?.data.isSuccess) {
          commit("setInspectors", response.data.data[0].inspectors);
        } else {
          console.log(response.data.msg);
          return false;
        }
      } catch (error) {
        console.error("Error fetching Inspectors:", error);
      }
    },
    /** */
    async fetchNationalities({ commit }) {
      try {
        const response = await axios.get(
          this.state.baseURL + "api/nationality/getall",
          { withCredentials: true }
        );
        if (response?.data.isSuccess) {
          commit("setNationalities", response.data.nationalities);
        } else {
          console.log(response.data.msg);
          return false;
        }
      } catch (error) {
        console.error("Error fetching Nationalities:", error);
      }
    },
    async fetchUser({ commit }) {
      try {
        if (sessionStorage?.getItem("user")) {
          commit("setUser", JSON.parse(sessionStorage.getItem("user")));
          return true;
        } else {
          const response = await axios.get(
            this.state.baseURL + "api/employee/user/getuser",
            { withCredentials: true }
          );
          if (response?.data.isSuccess) {
            commit("setUser", response.data.user);
          } else {
            console.log(response.data.msg);
            router.push({ name: "AdminLogin" });
            return false;
          }
        }
      } catch (error) {
        console.error("Error fetching user:", error);
        router.push({ name: "AdminLogin" });
      }
    },
  },
});

export default store;
